<template>
	<div class="costs-summary-table">
		<costs-summary-title :module-number="moduleNumber" :number-of-modules="numberOfModules"
			:show-print-info="showPrintInfo"/>

		<costs-summary-headers/>

		<costs-summary-row
			text="Z dotacji"
			:value="formatMoney(costsSummary.dotation)"
			:index="1"
		></costs-summary-row>

		<costs-summary-row
			text="Inne środki finansowe ogółem"
			:index="2"
			:value="formatMoney(financialContribution)"
		></costs-summary-row>

		<costs-summary-sub-row
			text="Środki finansowe własne"
			:index="2.1"
			:value="formatMoney(costsSummary.ownFinancialContribution)"
		></costs-summary-sub-row>

		<costs-summary-sub-row
			text="Świadczenia pieniężne od odbiorców"
			:index="2.2"
			:value="formatMoney(costsSummary.moneyFromRecipients)"
		></costs-summary-sub-row>

		<costs-summary-sub-row
			text="Środki finansowe z innych źródeł publicznych"
			:index="2.3"
			:value="formatMoney(costsSummary.otherPublicSource)"
		></costs-summary-sub-row>

		<costs-summary-sub-row
			text="Pozostałe"
			:index="2.4"
			:value="formatMoney(costsSummary.other)"
		></costs-summary-sub-row>

		<costs-summary-row
			text="Wkład osobowy i rzeczowy ogółem"
			:index="3"
			:value="formatMoney(ownContribution)"
		></costs-summary-row>

		<costs-summary-sub-row
			text="Wkład osobowy"
			:index="3.1"
			:value="formatMoney(costsSummary.ownHumanContribution)"
		></costs-summary-sub-row>

		<costs-summary-sub-row
			text="Wkład rzeczowy"
			:index="3.2"
			:value="formatMoney(costsSummary.ownContributionInKind)"
		></costs-summary-sub-row>

		<costs-summary-row
			text="Ogółem"
			:index="4"
			:value="formatMoney(totalCosts)"
		></costs-summary-row>

		<costs-summary-row
			text="Udział wkładu własnego w stosunku do kwoty dotacji"
			:index="5"
			:isPercentage="true"
			:value="totalContributionToDotationPercentage"
		></costs-summary-row>

		<costs-summary-row
			text="Udział kwoty dotacji w całkowitych kosztach"
			:index="6"
			:isPercentage="true"
			:value="dotationToWholePercentage"
		></costs-summary-row>

		<costs-summary-row
			text="Udział innych środków finansowych w stosunku do kwoty dotacji"
			:index="7"
			:isPercentage="true"
			:value="financialContributionToDotationPercentage"
		></costs-summary-row>

		<costs-summary-row
			text="Udział wkładu osobowego i wkładu rzeczowego w stosunku do kwoty dotacji"
			:index="8"
			:isPercentage="true"
			:value="ownContributionToDotationPercentage"
		></costs-summary-row>

		<div
			v-for="error in errors"
			:key="error"
		>
			<egranty-validation-error
				:error="error"
			></egranty-validation-error>
		</div>
	</div>
</template>

<script>

	import CostsSummaryRow from "./CostsSummaryRow";
	import CostsSummaryHeaders from "./CostsSummaryHeaders";
	import CostsSummaryTitle from "./CostsSummaryTitle";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";
	import {FinancialSettings} from "@/api/generated/FinancialSettings";
	import {Numbers} from "@/utils/Numbers";
	import CostsSummarySubRow from "./CostsSummarySubRow";
	import {Api} from "@/api";

	export default {
		name: "CostsSummaryTable",
		components: {
			EgrantyValidationError,
			CostsSummaryTitle,
			CostsSummaryHeaders,
			CostsSummaryRow,
			CostsSummarySubRow,
		},
		computed: {

			totalContributionToDotationPercentage() {
				return Numbers.methods.formatPercentage(this.totalContribution, this.costsSummary.dotation);
			},

			ownContributionToDotationPercentage() {
				return Numbers.methods.formatPercentage(this.ownContribution, this.costsSummary.dotation);
			},

			financialContributionToDotationPercentage() {
				return Numbers.methods.formatPercentage(this.financialContribution, this.costsSummary.dotation);
			},

			dotationToWholePercentage() {
				return Numbers.methods.formatPercentage(this.costsSummary.dotation, this.totalCosts);
			},
		},

		mounted() {
			FinancialSettings.getOfferData(this,this.contestId,this.moduleNumber,this.mainCountryId,this.mainBidderId, response =>{
				this.financialSettings = response.financialSettings;
				this.financialLimits = response.singleFinancialLimit;
				// this.legalFormLimits = response.legalFormLimits;
			});
			// pobieram współczynniki 
			FinancialSettings.getFinancialLimitsModulesPercentageDotation(this, this.$route.params.id, response => {
					this.moduleFinancialPercentageDotationConfig = response;
			});
			FinancialSettings.getFinancialLimitsModulesPercentage(this, this.$route.params.id, response => {
					this.moduleFinancialPercentageConfig = response;
			});
			if (!this.orderData) {
				// Pobranie danych oferty
				if(this.readonly){
					Api.syncGet(
					this,
					"/offer/data-readonly?offerId=".concat(this.offerDataId),
					this.setOrderData,
					errorResponse => this.$messagesBus.$emit("error", "Nie udało się wczytać oferty!", errorResponse),
				);
				} else {
				Api.syncGet(
					this,
					"/offer/data?offerId=".concat(this.offerDataId),
					this.setOrderData,
					errorResponse => this.$messagesBus.$emit("error", "Nie udało się wczytać oferty!", errorResponse),
				);
				}
			} else {
				this.setOrderData(this.orderData);
			}
		},

		methods: {
			setOrderData(response) {
				this.costsSummary  = response.stepsConstantData[this.moduleNumber - 1].costsCalculated.costsSummary;
				this.financialContribution = response.stepsConstantData[this.moduleNumber - 1].costsCalculated.financialContribution;
				this.ownContribution = response.stepsConstantData[this.moduleNumber - 1].costsCalculated.ownContribution;
				this.totalContribution = response.stepsConstantData[this.moduleNumber - 1].costsCalculated.totalContribution;
				this.totalCosts = response.stepsConstantData[this.moduleNumber - 1].costsCalculated.totalCosts;
				this.firstModuleCostsSummary = response.stepsConstantData[0].costsCalculated.costsSummary;
				this.firstModuleTotalCosts = response.stepsConstantData[0].costsCalculated.totalCosts;
			},
			validate() {
				this.errors = [];
				let valid = true;

				let administrativeLimit = this.offerConfiguration.modulePriceLimit[this.moduleNumber - 1].percentAdministrativeLimit;

				if (administrativeLimit !== null) {
					let max;
					let appendix = "";
					if (this.offerConfiguration.modulePriceLimit[this.moduleNumber - 1].percentAdministrativeRelativeToWholeCosts) {
						max = (administrativeLimit / 100) * (this.totalCosts);
						appendix = " w odniesieniu do całości kosztów";
					} else {
						max = (administrativeLimit / 100) * (this.costsSummary.dotation);
						appendix = " w odniesieniu do wnioskowanej dotacji";
					}
					max = Math.round(max * 100) / 100;
					if (this.costsSummary.administrative > max) {
						this.errors.push("Został przekroczony limit kosztów administracyjnych (" + Numbers.methods.formatMoney(max) + " PLN, czyli " + administrativeLimit.toFixed(2).replace(/\./g, ",") + "% " + appendix + ")");
						valid = false;
					}
				}

				let minOwnContributionLimit = this.offerConfiguration.modulePriceLimit[this.moduleNumber - 1].percentMinOwnContributionLimit;

				if (minOwnContributionLimit !== null) {
					let max;
					let appendix = "";
					if (this.offerConfiguration.modulePriceLimit[this.moduleNumber - 1].percentMinOwnContributionRelativeToWholeCosts) {
						max = (minOwnContributionLimit / 100) * (this.totalCosts);
						appendix = " w odniesieniu do całości kosztów";
					} else {
						max = (minOwnContributionLimit / 100) * (this.costsSummary.dotation);
						appendix = " w odniesieniu do wnioskowanej dotacji";
					}
					max = Math.round(max * 100) / 100;
					if (this.totalContribution < max) {
						this.errors.push("Nie został osiągnięty próg wkładu własnego (" + max + " PLN, czyli " + minOwnContributionLimit.toFixed(2).replace(/\./g, ",") + "%" + appendix + ")");
						valid = false;
					}
				}

				let maxOwnContributionLimit = this.offerConfiguration.modulePriceLimit[this.moduleNumber - 1].percentMaxOwnContributionLimit;

				if (maxOwnContributionLimit !== null) {
					let min;
					let appendix = "";
					if (this.offerConfiguration.modulePriceLimit[this.moduleNumber - 1].percentMaxOwnContributionRelativeToWholeCosts) {
						min = (maxOwnContributionLimit / 100) * (this.totalCosts);
						appendix = " w odniesieniu do całości kosztów";
					} else {
						min = (maxOwnContributionLimit / 100) * (this.costsSummary.dotation);
						appendix = " w odniesieniu do wnioskowanej dotacji";
					}
					min = Math.round(min * 100) / 100;
					if (this.totalContribution > min) {
						this.errors.push("Został przekroczony próg wkładu własnego (" + Numbers.methods.formatMoney(min) + " PLN, czyli " + maxOwnContributionLimit.toFixed(2).replace(/\./g, ",") + "%" + appendix + ")");
						valid = false;
					}
				}

				if (!this.financialSettings.fundingPerCountry) {	// limity dofinansowania ustalone globalnie na konkurs
					if (this.costsSummary.dotation < this.financialSettings.minFunding) {
						let descriptionVariable = (this.numberOfModules > 1) ? "modułu" : "konkursu";
						this.errors.push("Nie został osiągnięty próg minimalnej dotacji określony dla tego "+descriptionVariable+" (" + Numbers.methods.formatMoney(this.financialSettings.minFunding) + " PLN)");
						valid = false;
					}
					if (this.costsSummary.dotation > this.financialSettings.maxFunding) {
						let descriptionVariable = (this.numberOfModules > 1) ? "modułu" : "konkursu";
						this.errors.push("Został przekroczony limit dotacji określony dla tego "+descriptionVariable+" (" + Numbers.methods.formatMoney(this.financialSettings.maxFunding) + " PLN)");
						valid = false;
					}
				} else if (!this.financialSettings.fundingPerLegalFormPerCountry) {	// limity dofinansowania ustalone w zależności od kraju
					if (this.costsSummary.dotation < this.financialLimits.minFunding) {
						this.errors.push("Nie został osiągnięty próg minimalnej dotacji dla tego państwa (" + Numbers.methods.formatMoney(this.financialLimits.minFunding) + " PLN)");
						valid = false;
					}
					if (this.financialLimits.maxFunding && this.costsSummary.dotation > this.financialLimits.maxFunding) {
						this.errors.push("Został przekroczony limit dotacji dla tego państwa (" + Numbers.methods.formatMoney(this.financialLimits.maxFunding) + " PLN)");
						valid = false;
					}
				} else {	// limity dofinansowania ustalone w zależności od kraju i formy prawnej

					if (this.costsSummary.dotation < this.financialLimits.minFunding) {
						this.errors.push("Nie został osiągnięty próg minimalnej dotacji dla tego państwa wyznaczony dla tej formy prawnej (" + Numbers.methods.formatMoney(this.financialLimits.minFunding) + " PLN)");
						valid = false;
					}
					if (this.financialLimits.maxFunding && this.costsSummary.dotation > this.financialLimits.maxFunding) {
						this.errors.push("Został przekroczony limit dotacji dla tego państwa wyznaczony dla tej formy prawnej (" + Numbers.methods.formatMoney(this.financialLimits.maxFunding) + " PLN)");
						valid = false;
					}
				}

				// dodatkowa walidacja pomiędzy moduładmi: validacja 1. -> wnioskowanej kwoty dotacji
				if(this.moduleFinancialPercentageDotationConfig && this.moduleFinancialPercentageDotationConfig.createPercentageModuleValues && this.moduleNumber > 1){
					let actualPercentageModuleFactor = this.moduleFinancialPercentageDotationConfig.moduleFinancialPercentageSettings.find(x=>x.moduleNumber == this.moduleNumber).percentageRelativeValue;
					if(actualPercentageModuleFactor){
					let maxDotationBasedOnFirstModule = (actualPercentageModuleFactor / 100) * this.firstModuleCostsSummary.dotation;
					if(this.costsSummary.dotation > maxDotationBasedOnFirstModule ){
						this.errors.push("Przekroczono wartość wnioskowanej kwoty dotacji w stosunku do modułu 1. Maksymalna wartość wynosi: " 
						+ Numbers.methods.formatMoney(maxDotationBasedOnFirstModule) + " PLN");
						valid = false;
						}
					}
				}

				// dodatkowa walidacja pomiędzy moduładmi: validacja 2. całkowita wartość projektu
				if(this.moduleFinancialPercentageConfig && this.moduleFinancialPercentageConfig.createPercentageModuleValues && this.moduleNumber > 1){
					let actualPercentageModuleFactor = this.moduleFinancialPercentageConfig.moduleFinancialPercentageSettings.find(x=>x.moduleNumber == this.moduleNumber).percentageRelativeValue;
					if(actualPercentageModuleFactor){
					let maxtotalCostsBasedOnFirstModule = (actualPercentageModuleFactor / 100) * this.firstModuleTotalCosts;
					if(this.totalCosts > maxtotalCostsBasedOnFirstModule ){
						this.errors.push("Przekroczono wartość całkowitej wartości projektu w stosunku do modułu 1. Maksymalna wartość wynosi: " 
						+ Numbers.methods.formatMoney(maxtotalCostsBasedOnFirstModule) + " PLN");
						valid = false;
						}
					}
				}

				return valid;
			},


		},

		data() {
			return {
				errors: [],
				financialSettings: undefined,
				countrySettings: undefined,
			financialLimits: undefined,
			moduleFinancialPercentageConfig: undefined,
			costsSummary :{},
			financialContribution : 0,
			ownContribution : 0,
			totalContribution : 0,
			totalCosts : 0,
			firstModuleCostsSummary: {},
			firstModuleTotalCosts: 0,
			};
		},


		props: {
			offerDataId: {},
			offerConfiguration: Object,
			mainCountryId: {},
			mainBidderId: {},
			contestId: {},
			numberOfModules: {
				default: 0
			},
			moduleNumber: {
				default: ''
			},
			showPrintInfo: {
				type: Boolean, default: false
			},
			offerData: {},
			readonly: {type: Boolean, default: false}
		},

		mixins: [
			Numbers,
		],
	};
</script>

<style scoped>

</style>